import i18n from 'locales/i18n';

/**
 * Canonical subject keys for taxonomy cascade matching, URL ?subject=, and
 * get_editorial_list filters. Keep API originals (`math`, `Chinese`) — never
 * rewrite math to the display label 幼兒數學 (that broke list search).
 */
export function normalizeSubjectName(subject: string) {
  if (/^(chinese|中文|中文科|幼兒中文|中國語文|mc_chinese)$/i.test(subject)) return 'Chinese';
  if (/^(math|mc_math|幼兒數學|數學|幼儿数学)$/i.test(subject)) return 'math';
  return subject;
}

/** UI label for a canonical subject key (sidebar, filter dropdowns, editor). */
export function getSubjectDisplayName(subject: string): string {
  const canonical = normalizeSubjectName(subject);
  if (canonical === 'math') return i18n.t('common.subject.math');
  if (canonical === 'Chinese') return i18n.t('common.subject.chinese');
  return canonical;
}
